import { CrmEntityType, Prisma } from '@prisma/client';

export function dueRecordsWhere(now: Date, entityType?: CrmEntityType): Prisma.CrmSyncRecordWhereInput {
  return { dueAt: { lte: now }, ...(entityType && { entityType }), isTerminal: false };
}

export function quarantinedWhere(entityType?: CrmEntityType): Prisma.CrmSyncRecordWhereInput {
  return { isTerminal: false, quarantinedAt: { not: null }, ...(entityType && { entityType }) };
}

export function unmappedWhere(): Prisma.CrmSyncRecordWhereInput {
  return { crmObjectId: null, isTerminal: false };
}

export const CLAIMED_RECORD_SELECT = {
  createPendingAt: true,
  crmObjectId: true,
  entityId: true,
  entityType: true,
  failureCount: true,
  id: true,
  isPlatformDeleted: true,
} as const;

export type ClaimedRecord = Prisma.CrmSyncRecordGetPayload<{ select: typeof CLAIMED_RECORD_SELECT }>;

export type ContactEntityIdentity = {
  isSecondaryUser: boolean;
  secondaryEmail?: string;
  userId: string;
};

export function buildContactEntityId(userId: string, email: string): string {
  return `${userId}:${email.toLowerCase()}`;
}

/** Secondary contacts are keyed `userId:email`; user IDs never contain a colon. */
export function parseContactEntityId(entityId: string): ContactEntityIdentity {
  const separatorIndex = entityId.indexOf(':');

  if (separatorIndex === -1) {
    return { isSecondaryUser: false, userId: entityId };
  }

  return {
    isSecondaryUser: true,
    secondaryEmail: entityId.slice(separatorIndex + 1),
    userId: entityId.slice(0, separatorIndex),
  };
}
